import React, { createContext, useContext, useEffect, useState } from 'react';
import axios from 'axios';
// import { useSearchParams } from 'react-router-dom';

const FixingContext = createContext();

export const useFixing = () => {
    return useContext(FixingContext);
};

export const FixingProvider = ({ children }) => {
    const [isVisible, setIsVisible] = useState(true);
    const [showFixing, setShowFixing] = useState(false);
    const [prezzo, setPrezzo] = useState("");
    const [variazione, setVariazione] = useState("");
    const [prezzoSpot, setPrezzoSpot] = useState("");
    const [variazioneSpot, setVariazioneSpot] = useState("");
    const [oraSpot, setOraSpot] = useState("");
    const [bullBear, setBullBear] = useState();
    const [bullBearSpot, setBullBearSpot] = useState();
    const [loading, setLoading] = useState(true);
    const [error, setError] = useState(null);
    // const [searchParams] = useSearchParams();
    // const section = searchParams.get('section');
    const [selectedSubOption, setSelectedSubOption] = useState(0);
    const [isModalVisible, setModalVisible] = useState(true);


    useEffect(() => {
        if (variazione !== "") {
            const number = parseFloat(variazione);
            if (!isNaN(number)) {
                setBullBear(number >= 0);
            } else {
                console.log("The input is not a valid number.");
            }
        }
    }, [variazione]);

    useEffect(() => {
        if (variazioneSpot !== "") {
            const number = parseFloat(variazioneSpot);
            if (!isNaN(number)) {
                setBullBearSpot(number >= 0);
            } else {
                console.log("The input is not a valid number.");
            }
        }
    }, [variazioneSpot]);



    const isSmallDevice = window.innerWidth < 768;

    useEffect(() => {
        const fetchGoldPrice = () => {
            axios
                .get(
                    "https://crm.careholding.it/ws/Call/?Cat=Oro&met=GetPrezzoOroWeb&np=0",
                    {
                        headers: {
                            "Content-Type": "application/json",
                        },
                    }
                )
                .then((response) => {
                    const [prezzoFixing, variazioneFixing, prezzoSpot, variazioneSpot, oraSpot] = response.data.split("#");

                    setPrezzo(prezzoFixing);
                    setVariazione(variazioneFixing);
                    setPrezzoSpot(prezzoSpot);
                    setVariazioneSpot(variazioneSpot);
                    setOraSpot(oraSpot);
                    setShowFixing(true);
                })
                .catch((error) => {
                    console.error("An error occurred:", error);
                    setError("Failed to fetch data. Please try again later.");
                })
                .finally(() => {
                    setLoading(false);
                });
        };

        // First call immediately
        fetchGoldPrice();

        // Then every 30 seconds
        const intervalId = setInterval(fetchGoldPrice, 30000);

        if (isSmallDevice) {
            const timeoutId = setTimeout(() => {
                setIsVisible(false);
            }, 10000);

            return () => {
                clearInterval(intervalId);
                clearTimeout(timeoutId);
            };
        }

        return () => {
            clearInterval(intervalId);
        };
    }, []);


    const handleFixingShow = () => {
        setIsVisible(!isVisible);

    };

    const value = {
        isVisible,
        setIsVisible,
        showFixing,
        prezzo,
        variazione,
        prezzoSpot,
        variazioneSpot,
        oraSpot,
        bullBear,
        bullBearSpot,
        loading,
        error,
        handleFixingShow,
        selectedSubOption,
        setSelectedSubOption,
        isModalVisible,
        setModalVisible
    };

    return (
        <FixingContext.Provider value={value}>
            {children}
        </FixingContext.Provider>
    );
};
